import { BaseRenderable } from "./base_renderable"

export class Blank extends BaseRenderable {
    constructor() {
        super()
        this.drawCircle(0, 0, 1)
    }
}
